export const printOld = (printString: string) => {
  const newWindow = window.open(window.location.origin, '_blank')!;
  if (!newWindow) {
    throw new Error('Popup is blocked.');
  }

  newWindow.focus();
  newWindow.document.open();
  newWindow.document.write(printString);
  newWindow.document.close();
  Promise.all(
    Array.from(newWindow.document.querySelectorAll('img'))
      .filter((img) => !img.complete)
      .map(
        (img) =>
          new Promise((resolve) => {
            img.onload = img.onerror = resolve;
          })
      )
  ).then(() => {
    newWindow.print();
  });
};

export const print = (content: string) => {
  const newIframe = document.createElement('iframe');
  newIframe.name = 'print_frame';
  newIframe.width = '0';
  newIframe.height = '0';
  newIframe.src = 'about:blank';
  document.body.appendChild(newIframe);

  const iframeDoc = newIframe.contentWindow?.document;

  if (!iframeDoc) {
    console.error('Failed to access iframe document.');
    return;
  }

  iframeDoc.open();
  iframeDoc.write(content);
  iframeDoc.close();
  newIframe.contentWindow?.focus();
};

export const printPosInvoice = (content: string) => {
  const newIframe = document.createElement('iframe');
  newIframe.name = 'print_frame';
  newIframe.width = '0';
  newIframe.height = '0';
  newIframe.src = 'about:blank';
  document.body.appendChild(newIframe);

  // @ts-ignore
  window.frames['print_frame'].document.body.innerHTML = content;
  // @ts-ignore
  window.frames['print_frame'].window.focus();

  Promise.all(
    // @ts-ignore
    Array.from(window.frames['print_frame'].document.querySelectorAll('img') as HTMLImageElement[])
      .filter((img) => !img.complete)
      .map(
        (img) =>
          new Promise((resolve) => {
            img.onload = img.onerror = resolve;
          })
      )
  ).then(() => {
    // @ts-ignore
    window.frames['print_frame'].window.print();
    // document.body.removeChild(newIframe);
  });
};
